module.exports = __webpack_public_path__ + "static/img/OPPO Find X8 Pro.a851a173.png";